import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Head } from '@aviv-unified-frontend/runtime/head';
import { getAssetsPath } from '@/helpers/getAssetsPath';
export const HtmlMetas = () => {
    return (_jsxs(Head, { children: [_jsx("script", { children: `
                window.ddjskey = '8C7191D8AA1BF5FBB1B84DC7268196';
                window.ddoptions = { ajaxListenerPath: true };
                ` }), _jsx("script", { src: "https://js.datadome.co/tags.js", async: true }), _jsx("script", { src: getAssetsPath('tracking.js'), defer: true }), _jsx("meta", { name: "viewport", content: "width=device-width, height=device-height, initial-scale=1, minimum-scale=1, maximum-scale=1, user-scalable=no" }), _jsx("link", { rel: "icon", href: getAssetsPath('favicon.ico') })] }));
};
